/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ClaimApiConfiguration } from '../claim-api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';



/**
 * the ClaQueryAuthenticationTest API
 */
@Injectable({
  providedIn: 'root',
})
export class ClaQueryAuthenticationTestService extends BaseService {
  constructor(
    config: ClaimApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation claimClaimIdAuthenticationTestGet
   */
  static readonly ClaimClaimIdAuthenticationTestGetPath = '/claim/{claimId}/authentication/test';

  /**
   * Verify claimant.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `claimClaimIdAuthenticationTestGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  claimClaimIdAuthenticationTestGet$Response(params: {
    claimId: string;
    'X-Authorization'?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ClaQueryAuthenticationTestService.ClaimClaimIdAuthenticationTestGetPath, 'get');
    if (params) {
      rb.path('claimId', params.claimId, {});
      rb.header('X-Authorization', params['X-Authorization'], {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Verify claimant.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `claimClaimIdAuthenticationTestGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  claimClaimIdAuthenticationTestGet(params: {
    claimId: string;
    'X-Authorization'?: string;
  },
  context?: HttpContext

): Observable<void> {

    return this.claimClaimIdAuthenticationTestGet$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
